import { render, staticRenderFns } from "./BrowseCataloguePatents.vue?vue&type=template&id=ce2c3f78&scoped=true"
import script from "./BrowseCataloguePatents.vue?vue&type=script&lang=js"
export * from "./BrowseCataloguePatents.vue?vue&type=script&lang=js"
import style0 from "./BrowseCataloguePatents.vue?vue&type=style&index=0&id=ce2c3f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2c3f78",
  null
  
)

export default component.exports